export default __webpack_public_path__ + "static/media/MOZ.4cebf734.svg";